export default __webpack_public_path__ + "static/sweepstakes-grand-1-e678dccdd88535e79317e76eed3155f6.jpg";